window.getPriceForSelectedOptions = function (type = 'price') {
    const priceElement = $('[name="price_value"]');
    let price = 0;
    if(type === 'price'){
        price = parseFloat(priceElement.val().replace(/^.*?(\d+(\.\d+)?).*?$/, "$1"));
    }
    if(type === 'price-val'){
        price = parseFloat($('[data-price-val]').data('price-val'));
    }
    if(type === 'special-val'){
        price = parseFloat($('[data-special-val]').data('special-val'));
    }

    $('select[name*="option"]').each(function () {
        let operation = $(this).find('option:selected').data('option-price-prefix');
        let o_price = $(this).find('option:selected').data('option-price');
        if (o_price && operation) {
            if (operation === '+') {
                price = price + parseFloat(o_price.replace('.', '').replace(/^.*?(\d+(\.\d+)?).*?$/, "$1"));
            } else if (operation === '-') {
                price = price - parseFloat(o_price.replace('.', '').replace(/^.*?(\d+(\.\d+)?).*?$/, "$1"));
            }
        }
    });
    $('input[name*="option"][type="radio"]:checked').each(function () {
        let operation = $(this).data('option-price-prefix');
        let o_price = $(this).data('option-price');
        if (o_price && operation) {
            if (operation === '+') {
                price = price + parseFloat(o_price.replace('.', '').replace(/^.*?(\d+(\.\d+)?).*?$/, "$1"));
            } else if (operation === '-') {
                price = price - parseFloat(o_price.replace('.', '').replace(/^.*?(\d+(\.\d+)?).*?$/, "$1"));
            }
        }
    });
    $('input[name*="option"][type="checkbox"]:checked').each(function () {
        let operation = $(this).data('option-price-prefix');
        let o_price = $(this).data('option-price');
        if (o_price && operation) {
            if (operation === '+') {
                price = price + parseFloat(o_price.replace('.', '').replace(/^.*?(\d+(\.\d+)?).*?$/, "$1"));
            } else if (operation === '-') {
                price = price - parseFloat(o_price.replace('.', '').replace(/^.*?(\d+(\.\d+)?).*?$/, "$1"));
            }
        }
    });

    return price;
}
window.optionChanged = function () {
    calculatePriceAndQuantity();
    updateModel();
}
window.updateModel = function () {
    let model = $model;

    $('select[name*="option"] option:selected, input[name*="option"][type="radio"]:checked, input[name*="option"][type="checkbox"]:checked').each(function () {
        const model_part = $(this).data('ciopmodel');
        if(model_part){
            model += model_part;
        }
    });
    $('#product-model').html(model);

}
window.calculatePriceAndQuantity = function () {
    const virtualQuantityEl = $('[name="virtual_quantity"]');
    const priceValEl = $('[data-price-val]');
    const specialValEl = $('[data-special-val]');
    const priceSqmEl = $('[data-price-sqm]');
    const specialSqmEl = $('[data-special-sqm]');

    let selected_quantity = 1;
    if(virtualQuantityEl.length) {
        selected_quantity = $('[name="virtual_quantity"]').val();
    }
    let quantity = Math.max($product_minimum, selected_quantity);
    if ($option_densitate_id != '0') {
        const optionLengthElement = $(optionLengthElementSelector);

        if (optionLengthElement.length === 0) {
            return false;
        }

        quantity = parseInt(optionLengthElement.val()) / 100;
    } else if ($option_height_id != '0' && $option_width_id  != '0') {
        const optionHeightElement = $('#input-option' + $option_height_id);
        const optionWidthElement = $('#input-option' + $option_width_id);

        if (optionHeightElement.length === 0 || optionWidthElement.length === 0) {
            return 0;
        }

        quantity = Math.max($product_minimum, parseInt(optionWidthElement.val()) * parseInt(optionHeightElement.val()) / 10000);
    }
    if (isNaN(quantity)) {
        quantity = Math.max($product_minimum, selected_quantity);
    }
    quantity = Math.max(1, quantity);

    if(priceValEl.length) {
        priceValEl.text(new Intl.NumberFormat('ro-Ro', {
            style: 'currency',
            currency: 'lei'
        }).format((getPriceForSelectedOptions('price-val')).toFixed(2)).toLowerCase());
    }
    if(specialValEl.length) {
        specialValEl.text(new Intl.NumberFormat('ro-Ro', {
            style: 'currency',
            currency: 'lei'
        }).format((getPriceForSelectedOptions('special-val')).toFixed(2)).toLowerCase());
    }
    if(priceSqmEl.length) {
        priceSqmEl.text(new Intl.NumberFormat('ro-Ro', {
            style: 'currency',
            currency: 'lei'
        }).format((getPriceForSelectedOptions('price-val')/parseFloat(priceSqmEl.data('price-sqm'))).toFixed(2)).toLowerCase());
    }
    if(specialSqmEl.length) {
        specialSqmEl.text(new Intl.NumberFormat('ro-Ro', {
            style: 'currency',
            currency: 'lei'
        }).format((getPriceForSelectedOptions('special-val')/parseFloat(specialSqmEl.data('special-sqm'))).toFixed(2)).toLowerCase());
    }

    const price = getPriceForSelectedOptions();
    $('#calculated-quantity').text(parseFloat(quantity).toFixed(1));
    if(virtualQuantityEl.length) {
        virtualQuantityEl.val(parseInt(quantity));
    }
    $('[name="quantity"]').val(parseFloat(quantity).toFixed(1));
    $('#calculated-price').text(new Intl.NumberFormat('ro-Ro', {
        style: 'currency',
        currency: 'lei'
    }).format((quantity.toFixed(1) * price).toFixed(1)));
}
window.productCartAdd = function (data = null) {
    if(!data){
        data = $('#product input[type=\'text\'], #product input[type=\'number\'], #product input[type=\'hidden\'], #product input[type=\'radio\']:checked, #product input[type=\'checkbox\']:checked, #product select, #product textarea');
    }
    customAjaxRequest('index.php?route=checkout/cart/add', 'post', data, function () {
    }, function (json) {
        if(typeof timer != 'undefined'){
            clearTimeout(timer);
        }
        $('.alert, .invalid-feedback').remove();
        $('.is-invalid').removeClass('is-invalid');

        if (json['error']) {
            if (json['error']['option']) {
                for (i in json['error']['option']) {
                    var element = $('#input-option' + i.replace('_', '-'));

                    if (element.parent().hasClass('input-group')) {
                        element.addClass('is-invalid').parent().after('<div class="invalid-feedback">' + json['error']['option'][i] + '</div>');
                    } else {
                        element.addClass('is-invalid').after('<div class="invalid-feedback">' + json['error']['option'][i] + '</div>');
                    }
                }
            }

            if (json['error']['quantity']) {
                alertMessage('pink-dark', 'exclamation-circle', json['error']['quantity'])
            }
        }

        if (json['success']) {
            $('#cart').load('index.php?route=common/cart/info #cart > *', function () {
                setTimeout(function () {
                    const cartModalEl = document.getElementById('cartModal');
                    const cartModal = bootstrap.Modal.getOrCreateInstance(cartModalEl);
                    cartModal.show();
                }, 500);
            });

            klaviyoAddedtoCart($('[name="product_id"]').val(), $('[name="quantity"]').val());
        }
        timer = setTimeout(function () {
            $('.alert').addClass('fadeOut');
        }, 4000)
    });
}
window.productSampleAdd = function (json_string) {
    const ciopmodel = $('input[data-ciopmodel^="-"]:checked').data('ciopmodel');
    let json = JSON.parse(json_string.replaceAll("'", '"'));
    if (typeof ciopmodel !== 'undefined') {
        json.option['17734'] = json.option['17734'] + ciopmodel;
    }

    productCartAdd(json);
}
window.calculateRolaPerInput = function() {
    const rola_width = parseFloat($rola_width);
    const rola_height = parseFloat($rola_height);
    const input_width = parseFloat($('#input-rola-calculator-width').val())/100;
    const input_height = parseFloat($('#input-rola-calculator-height').val())/100;
    const quantity = Math.ceil(((input_width*input_height)*1.3)/(rola_width*rola_height));
    if(quantity) {
        $('#rola-calculation-result').html('necesar: <b>' + quantity + '</b>');
    }else{
        $('#rola-calculation-result').html('introdu mai sus');
    }
    return quantity;
}
window.inputStep = function (el) {
    const step = parseInt(el.attr('step'));
    const d = el.val() % step;
    if (d > 0) {
        el.val(parseInt(el.val()) + step - d);
    }
}

window.createProductReview = function (product_id) {
    const url = 'index.php?route=product/product/write&product_id=' + product_id;
    customAjaxRequest(url, 'post', $("#form-review").serialize(), function () {
    }, function (json) {
        $('.alert').remove();

        if (json['error']) {
            $('#form-review').before('<div class="alert alert-pink"><i class="fa fa-exclamation-circle"></i> ' + json['error'] + '</div>');
        }

        if (json['success']) {
            $('#button-review').remove();
            $('#reviewsFormModalLabel').html('Recepționat');
            $('#form-review').replaceWith('<p>' + json['success'] + '</p>');
        }
    });
}
window.klaviyoAddedtoCart = function (product_id, quantity = 1){
    var _learnq = _learnq || [];
    customAjaxRequest('index.php?route=module/klaviyo/added_to_cart&product_id='+product_id+'&quantity=' + quantity, 'post', [], null, function (json) {
        if (json['klaviyo_addtocart_items']) {
            _learnq.push(["track", "Added to Cart", json['klaviyo_addtocart_items']]);
        }
    });
}

$(document).ready(function () {
    if($('body').hasClass('product-product')){
        if ($option_densitate_id != '0') {
            const inaltimeElement = $(optionInaltimeElementSelector);
            inaltimeElement.attr('max', inaltimeElement.val());
            inaltimeElement.attr('min', 1)

            $(inaltimeElement).change(function () {
                const max = parseInt($(this).attr('max'));
                if (parseInt($(this).val()) > max) {
                    $(this).val(max);
                }
                if (parseInt($(this).val()) < 1) {
                    $(this).val(1);
                }
            });
        }


        $('input[type="number"][step][name*="option"]').change(function () {
            inputStep($(this));
        });

        $('select[name*="option"]').change(function () {
            const text_value = $(this).find('option:selected').text();
            if (text_value.indexOf('@') > -1) {
                const tvp = text_value.split('@');
                if (tvp[1]) {
                    const tvp2 = tvp[1].split('cm');
                    const inputEl = $('input[type="number"][name*="option"][placeholder*="Lățime"]');
                    inputEl.val(parseInt(tvp2[0])).attr('step', parseInt(tvp2[0]));
                    inputEl.change(function () {
                        inputStep($(this));
                    });
                    inputEl.trigger('change');
                }

            }
        });

        $('select[name*="option"]').on("change", optionChanged);
        $('input[name*="option"][type="radio"]').on("change", optionChanged);
        $('input[name*="option"][type="checkbox"]').on("change", optionChanged);
        $('input[name*="option"][type="text"]').on("input", optionChanged);
        $('input[name*="option"][type="textarea"]').on("input", optionChanged);
        $('input[name*="option"][type="number"]').on("input, change", optionChanged);

        calculatePriceAndQuantity();

        $('#input-rola-calculator-width, #input-rola-calculator-height').on('input, change', calculateRolaPerInput);

        $('#rola-calculator-add-to-cart').click(function () {
            const quantity = calculateRolaPerInput();
            if(quantity) {
                $('[name="virtual_quantity"]').val(quantity);
                $('[name="quantity"]').val(quantity);
                productCartAdd();
                $('#rolaCalculatorModal').modal('hide');
            }
        });

        $('[name="virtual_quantity"]').on("change", function () {
            const quantity = $(this).val();
            $('[name="quantity"]').val(quantity);
        });

        if($show_review_modal == '1'){
            $('[data-bs-target="reviewsFormModal"]').click();
        }

        const firstRal = $('.rounded-circle[style*="aspect-ratio"]').first();
        const htmlSample = $('.sample-product-image__background');
        if(htmlSample.length && firstRal.length){
            htmlSample.css('background-color', firstRal.css('background-color'))
        }
    }
});
